import React from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import CommonTable from '../../components/CommonTable'

const PipelineDetails = () => {
  const { pipelines, isLoading } = useSelector((state) => state.pipelines)

  const columns = [
    {
      title: 'ADF Pipeline Name',
      dataIndex: 'adfPipelineName',
      key: 'adfPipelineName',
    },
    {
      title: 'Application Name',
      dataIndex: 'applicationName',
      key: 'applicationName',
    },
    {
      title: 'Source Server',
      dataIndex: 'sourceServer',
      key: 'sourceServer',
    },
    {
      title: 'Source Database',
      dataIndex: 'sourceDatabase',
      key: 'sourceDatabase',
    },
    {
      title: 'Destination Database',
      dataIndex: 'destinationDatabase',
      key: 'destinationDatabase',
    },
    {
      title: 'Destination Server',
      dataIndex: 'destinationServer',
      key: 'destinationServer',
    },
    {
      title: 'SinkDataset',
      dataIndex: 'sinkDataset',
      key: 'sinkDataset',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
  ]

  if (isLoading) {
    return <Spin size="large" />
  }

  if (!pipelines || pipelines.length === 0) {
    return <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>No data available</div>
  }

  return (
    <CommonTable
      columns={columns}
      dataSource={pipelines}
      rowKey="adfPipelineName"
    />
  )
}

export default PipelineDetails
